import { openDB } from "idb";
import type { DiceRoll } from "./dice";

const dbPromise = openDB("fallout2d20", 1, {
  upgrade: (database) => database.createObjectStore("state"),
});
const KEY = "dice-history-v1";

export async function loadDiceHistory(): Promise<DiceRoll[]> {
  return (await (await dbPromise).get("state", KEY)) ?? [];
}

export async function saveDiceRoll(roll: DiceRoll): Promise<DiceRoll[]> {
  const db = await dbPromise;
  const history = [roll, ...((await db.get("state", KEY)) ?? [])].slice(0, 50);
  await db.put("state", history, KEY);
  return history;
}
